import { useHistory } from 'react-router-dom';

export const useNavigate = () => {
  const history = useHistory();
  // eslint-disable-next-line @typescript-eslint/unbound-method
  return history.push;
};
